var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel", attrs: { id: "panel-4" } },
    [
      _c("div", { staticClass: "panel-hdr" }, [
        _c("h2", [
          _vm._v("\n\t\t\t\t" + _vm._s(_vm.__t("LIST")) + " "),
          _c("span", { staticClass: "fw-300" }, [
            _c("i", [_vm._v(_vm._s(_vm.__t("CATEGORIES")))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-toolbar" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed",
              on: { click: _vm.create },
            },
            [_c("i", { staticClass: "fal fa-plus" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-icon btn-sm btn-info shadow-0 waves-effect waves-themed mr-2",
              on: { click: _vm.remove_skip_sync },
            },
            [_c("i", { staticClass: "fal fa-money-check-edit-alt" })]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-container show pt-5 pb-5" }, [
        _c(
          "div",
          { staticClass: "panel-content" },
          [
            _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
              _c(
                "div",
                { staticClass: "rounded" },
                [
                  _vm.worked_categs.length > 0
                    ? _c("categ_node", {
                        attrs: { categories: _vm.worked_categs },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500",
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("categ_modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }